module.exports = __webpack_public_path__ + "static/media/proj4.8e03f996.webp";